import urls from './urls';
import {
  axiosPost, axiosPut, getSourceId, getUpdates
} from './common';
import { addAnalyticEvent } from '../analytics/common';
import { smsAnalytics } from '../analytics/save';
import {
  confirmConsentError,
  smsRetrievePageLoadError,
  unsubscribeFromAllSms, unsubscribeFromAllSmsError, unsubscribeFromAllSmsSuccess
} from '../analytics/sms';
import { NO, YES } from '../constants';

function populatePreferences(selected, table) {
  return selected.map((row) => {
    const entry = table[row];
    return {
      type: entry.type,
      status: entry.value
    };
  });
}

function retrieveSmsPreferences(phoneNumber, callback, err) {
  const request = {
    phoneNumber
  };

  const errorCallback = (error) => {
    addAnalyticEvent(smsRetrievePageLoadError);
    err(error);
  };

  axiosPost({
    url: urls.RETRIEVE_SMS,
    data: request,
    callback,
    err: errorCallback,
  });
}

function updateSmsPreferences(phoneNumber, selected, table, callback, err) {
  const preferences = populatePreferences(selected, table);
  let request = {
    phoneNumber,
    sourceId: getSourceId(),
    subscriptions: preferences
  };

  const successCallback = (res) => {
    try {
      callback(res);
    } finally {
      addAnalyticEvent(smsAnalytics(getUpdates(selected, table)));
    }
  };

  const errorCallback = (error) => {
    addAnalyticEvent(confirmConsentError);
    err(error);
  };

  axiosPut({
    url: urls.UPDATE_SMS,
    data: request,
    callback: successCallback,
    err: errorCallback,
  });
}

function buildUnsubscribeSmsRequest(phoneNumber) {
  return {
    sourceId: getSourceId(),
    phoneNumber,
    globalOptOut: YES,
    subscriptions: [
      {
        type: 'PROMOTIONS',
        status: NO
      },
      {
        type: 'PRO',
        status: NO
      }
    ]
  };
}

function unsubscribeFromAllMessages(phoneNumber, callback, err) {

  let request = buildUnsubscribeSmsRequest(phoneNumber);

  const successCallback = (res) => {
    try {
      callback(res);
    } finally {
      addAnalyticEvent(unsubscribeFromAllSmsSuccess);
    }
  };

  const errorCallback = (error) => {
    addAnalyticEvent(unsubscribeFromAllSmsError);
    err(error);
  };

  axiosPut({
    url: urls.UPDATE_SMS,
    data: request,
    callback: successCallback,
    err: errorCallback,
  });

}

export {
  retrieveSmsPreferences,
  updateSmsPreferences,
  unsubscribeFromAllMessages,
  populatePreferences
};
